import { B400, N200, N0 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
import styled from '@emotion/styled';

interface AppsCountCellProps {
  isAppPresent: boolean;
}

export const AppsCountCell = styled.span<AppsCountCellProps>`
  padding: 2px 8px;
  background-color: ${(props) =>
    props.isAppPresent
      ? token('color.background.accent.blue.bolder', B400)
      : token('color.background.accent.gray.bolder', N200)};
  color: ${token('color.text.inverse', N0)};
  border-radius: 16px;
  font-size: 12px;
`;
